import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: {
      getItem: (key) => {
        try {
          const value = localStorage.getItem(key);
          // Validate stored session data
          if (value) {
            try {
              const parsed = JSON.parse(value);
              // Check if refresh token exists in stored session
              if (parsed && !parsed?.refresh_token) {
                console.warn('Invalid session data detected, clearing...');
                localStorage.removeItem(key);
                return null;
              }
            } catch (parseError) {
              console.error('Session parse error:', parseError);
              localStorage.removeItem(key);
              return null;
            }
          }
          return value;
        } catch (error) {
          console.error('Storage getItem error:', error);
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          localStorage.setItem(key, value);
        } catch (error) {
          console.error('Storage setItem error:', error);
        }
      },
      removeItem: (key) => {
        try {
          localStorage.removeItem(key);
        } catch (error) {
          console.error('Storage removeItem error:', error);
        }
      }
    },
    // Add error recovery callback
    onAuthStateChange: undefined,
    flowType: 'implicit'
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    },
    fetch: (...args) => {
      return fetch(...args)?.catch(error => {
        console.error('Supabase fetch error:', error);
        throw error;
      });
    }
  }
});
